<template>
  <div class="common-layout">
    <el-container>
      <div class="top" @click="goMyInfo">
        <el-avatar shape="square" size="19.23077vw"
          :src="avatarSrc" class="avater" />
        <div class="name">{{ realName }}<div class="state">{{ politicalStatus }}</div></div>
        <div class="org">{{ orgName }}</div>
      </div>
      <div class="member-info">
        <div class="member-item">
          <div class="member-label">党龄</div>
          <div class="member-value">{{ partyAge }}</div>
        </div>
        <div class="member-item">
          <div class="member-label">政治生日</div>
          <div class="member-value">{{ politicalBirthday }}</div>
        </div>
      </div>
      <div class="feature-list">
        <div class="feature-item clickable-item" @click="goMyInfo">
          <div class="feature-left">
            <img :src="centerIcon" class="feature-icon" alt="个人中心图标" />
            <span class="feature-text">个人中心</span>
          </div>
          <span class="feature-arrow">&gt;</span>
        </div>
        <div class="feature-item clickable-item" @click="goQuestionFeedback">
          <div class="feature-left">
            <img :src="questionIcon" class="feature-icon" alt="问题反馈图标" />
            <span class="feature-text">问题反馈</span>
          </div>
          <span class="feature-arrow">&gt;</span>
        </div>
        <div class="feature-item clickable-item" @click="goAboutPage">
          <div class="feature-left">
            <img :src="aboutIcon" class="feature-icon" alt="关于我们图标" />
            <span class="feature-text">关于我们</span>
          </div>
          <span class="feature-arrow">&gt;</span>
        </div>
        <div class="feature-item clickable-item" @click="openLogoutConfirm">
          <div class="feature-left">
            <img :src="logoutIcon" class="feature-icon" alt="退出登录图标" />
            <span class="feature-text">退出登录</span>
          </div>
          <span class="feature-arrow">&gt;</span>
        </div>
      </div>
      <CommonConfirmDialog
        v-model="logoutDialogVisible"
        title="提示"
        :confirm-loading="isLogoutLoading"
        @confirm="handleLogoutConfirm"
      >
        <span>是否退出登录？</span>
      </CommonConfirmDialog>
      <el-footer>
        <BottomNav />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import BottomNav from '../component/BottomNav.vue';
import CommonConfirmDialog from '../component/CommonConfirmDialog.vue';
import { getUserProfile, logout } from '@/api';
import { removeToken } from '@/utils/auth';
import {
  formatDateOnly,
  formatPartyAge,
  getCachedUserProfile,
  removeCachedUserProfile,
  setCachedUserProfile
} from '@/utils/profile';
import femaleAvatar from '@/assets/img/mine/female.png';
import maleAvatar from '@/assets/img/mine/male.png';
import centerIcon from '@/assets/img/mine/center.png';
import questionIcon from '@/assets/img/mine/question.png';
import aboutIcon from '@/assets/img/mine/about.png';
import logoutIcon from '@/assets/img/mine/logout.png';

export default {
  name: 'basePage',
  data() {
    return {
      profileData: getCachedUserProfile(),
      logoutDialogVisible: false,
      isLogoutLoading: false,
      centerIcon,
      questionIcon,
      aboutIcon,
      logoutIcon
    };
  },
  components: {
    BottomNav,
    CommonConfirmDialog
  },
  computed: {
    info() {
      return this.profileData?.info || {};
    },
    realName() {
      return this.info.real_name || '--';
    },
    politicalStatus() {
      return this.info.political_status_text || '--';
    },
    orgName() {
      return this.info.org_name || '--';
    },
    partyAge() {
      return formatPartyAge(this.info.join_at, this.profileData?.dtime);
    },
    politicalBirthday() {
      return formatDateOnly(this.info.turn_forward_at);
    },
    avatarSrc() {
      return this.info.sex_text === '女' ? femaleAvatar : maleAvatar;
    }
  },
  mounted() {
    if (!this.profileData?.info?.id) {
      this.fetchUserProfile();
    }
  },
  methods: {
    goMyInfo() {
      this.$router.push('/mine/info');
    },
    goQuestionFeedback() {
      this.$router.push('/mine/question-feedback');
    },
    goAboutPage() {
      this.$router.push('/mine/about');
    },
    openLogoutConfirm() {
      this.logoutDialogVisible = true;
    },
    async handleLogoutConfirm() {
      this.isLogoutLoading = true;
      try {
        await logout();
      } catch (error) {
        // 退出接口失败时，仍继续清理本地登录态
      } finally {
        this.isLogoutLoading = false;
        this.logoutDialogVisible = false;
        removeToken();
        removeCachedUserProfile();
        this.$router.replace('/login');
      }
    },
    async fetchUserProfile() {
      try {
        const res = await getUserProfile();
        const payload = res?.data || null;
        if (payload) {
          this.profileData = payload;
          setCachedUserProfile(payload);
        }
      } catch (error) {
        // 错误提示已在全局请求拦截器中统一处理
      }
    }
  }
}
</script>

<style scoped lang="scss">
.common-layout {
  min-height: 100vh;
  background: #ffffff;
  padding-bottom: 18vw;
}

.top {
  position: relative;
  width: 100%;
  height: 50vw;
  background: #FF6060;
  border-bottom-left-radius: 50% 10%;
  border-bottom-right-radius: 50% 10%;
  cursor: pointer;

  .avater {
    position: absolute;
    top: 12vw; 
    left: 5.12821vw;
    width: 19.23077vw;
    height: 19.23077vw;
    background-color: transparent;
  }

  .name {
    display: flex;
    position: absolute;
    top: 14vw;
    left: 28.20513vw;
    color: white;
    font-size: 3.84615vw;

    .state {
      margin-left: 2.5641vw;
      padding: 0 1.28205vw;
      background: #ffa15c;
      border-radius: 1.28205vw;
    }
  }

  .org {
    position: absolute;
    top: 22vw;
    left: 28.20513vw;
    color: white;
    font-size: 3.84615vw;
  }
}

.member-info {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 95%;
  height: 25vw;
  margin-top: -12vw;
  background: #ffffff;
  border-radius: 3.84615vw;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);

  .member-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 30%;
    line-height: 1.4;
  }

  .member-label {
    font-size: 4.5vw;
    font-weight: 700;
    color: #1f1f1f;
  }

  .member-value {
    margin-top: 1vw;
    font-size: 4.5vw;
    font-weight: 700;
    color: #ff0000;
  }
}

.feature-list {
  margin-top: 3.84615vw;
  background: #fff;

  .feature-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 14vw;
    padding: 0 5.12821vw;
    border-bottom: 0.25641vw solid #ececec;
  }

  .clickable-item {
    cursor: pointer;
  }

  .feature-left {
    display: flex;
    align-items: center;
  }

  .feature-icon {
    width: 10vw;
    height: 10vw;
    margin-right: 3.07692vw;
    object-fit: contain;
    display: block;
  }

  .feature-text {
    font-size: 4vw;
    color: #1f1f1f;
    font-weight: 600;
  }

  .feature-arrow {
    font-size: 5vw;
    color: #1f1f1f;
    line-height: 1;
  }
}
</style>